import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import HybridPage from './pages/HybridPage';
import AIProcessPage from './pages/AIProcessPage';
import TestPage from './pages/TestPage';
import HistoryPage from './pages/HistoryPage';
import SelectionHistoryPage from './pages/SelectionHistoryPage';
import Groups from './pages/Groups';
import ClusterStudiesPage from './pages/ClusterStudiesPage';
import ClusterReviewPage from './pages/ClusterReviewPage';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/hybrid" replace />} />
          <Route
            path="/hybrid"
            element={
              <ProtectedRoute>
                <HybridPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/aiprocess"
            element={
              <ProtectedRoute>
                <AIProcessPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/test"
            element={
              <ProtectedRoute>
                <TestPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/history"
            element={
              <ProtectedRoute>
                <HistoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/groups"
            element={
              <ProtectedRoute>
                <Groups />
              </ProtectedRoute>
            }
          />
          <Route path="/selection-history" element={<ProtectedRoute><SelectionHistoryPage /></ProtectedRoute>} />
          <Route path="/cluster-studies" element={<ProtectedRoute><ClusterStudiesPage /></ProtectedRoute>} />
          <Route path="/cluster-review" element={<ProtectedRoute><ClusterReviewPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/hybrid" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
